import { Vue, Component, Prop } from 'vue-property-decorator'
import ConfigurationRelationships from '@/modules/configurationModule/shared/components/configuration-relationships/configuration-relationships.vue'
import { ConfigurationCaseTypeLaboratoryResponse, ConfigurationCaseTypeSampleTypeCreateRequest, ConfigurationCaseTypeSampleTypeResponse } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types.dto'
import { initialLocalCasesTypesModalBasicFormSampleTypesState, LocalCasesTypesModalBasicFormSampleTypesState } from '@/modules/configurationModule/detail/local-cases/local-case-types/components/local-case-types-modal-basic-form-sample-types/local-case-types-modal-basic-form-sample-types.model'
import { caseTypeLaboratoriesRelationshipSampleTypesConfigurationServices } from '@/modules/configurationModule/detail/local-cases/local-case-types/services/local-case-types-relationship-sample-types.service'
import { commonSampleClassificationService } from '@/api/resources/common/sample-classification/sample-classification.service'
import { CommonSampleTypeResponse } from '@/api/services/common/sample-type/common-sample-type.dto'
import { GridUtils } from '@/shared/util/grid-utils'

@Component({
    components: {
        ConfigurationRelationships
    }
})
export default class LocalCaseTypesModalBasicFormSampleTypes extends Vue {
    @Prop() readonly selectedRow!: ConfigurationCaseTypeLaboratoryResponse

    state: LocalCasesTypesModalBasicFormSampleTypesState
    constructor() {
        super()
        this.state = initialLocalCasesTypesModalBasicFormSampleTypesState()
    }

    private async _loadCaseTypeSampleTypes() {
        this.state.caseTypeSampleTypes = await this._getCaseTypeSampleTypes()
    }

    async mounted() {
        await this._loadCaseTypeSampleTypes()
    }

    async createRelationship({ id }: CommonSampleTypeResponse): Promise<void> {
        const request: ConfigurationCaseTypeSampleTypeCreateRequest = {
            caseTypeId: this.selectedRow.caseType.id,
            sampleTypeId: id
        }
        const [err] = await this.$_toCall(caseTypeLaboratoriesRelationshipSampleTypesConfigurationServices.createCaseTypeRelationshipSampleType(this.selectedRow.laboratory.labId, request))
        if (err) {
            this.$_showErrorModalFromErrorResponse(err)
            return
        }
        this.$_showToastSuccess(this.$t('configuration.toastMessages.caseTypesSampleTypeRelationshipEntityCreated') as string)

        await this._loadCaseTypeSampleTypes()
    }

    async deleteRelationship({ id }: CommonSampleTypeResponse): Promise<void> {
        const [err] = await this.$_toCall(caseTypeLaboratoriesRelationshipSampleTypesConfigurationServices.deleteCaseTypeRelationshipSampleType(this.selectedRow.laboratory.labId, id))
        if (err) {
            this.$_showErrorModalFromErrorResponse(err)
            return
        }
        this.$_showToastSuccess(this.$t('configuration.toastMessages.caseTypesSampleTypeRelationshipEntityDeleted') as string)

        await this._loadCaseTypeSampleTypes()
    }

    private async _getCaseTypeSampleTypes(): Promise<ConfigurationCaseTypeSampleTypeResponse[]> {
        const filterModel = {
            'caseType.id': GridUtils.getNumberFilterModel('equals', this.selectedRow.caseType.id)
        }
        const [err, response] = await this.$_toCall(caseTypeLaboratoriesRelationshipSampleTypesConfigurationServices.getCaseTypeRelationshipSampleType(filterModel, {}, this.selectedRow.laboratory.labId))
        if (err) {
            return []
        }
        return response?.content
    }

    async getSampleTypes(): Promise<CommonSampleTypeResponse[]> {
        const [err, response] = await this.$_toCall(commonSampleClassificationService.getCommonSampleTypeSampleClassificationsByLaboratory({ laboratoryId: this.selectedRow.laboratory.labId }))
        if (err) {
            return []
        }
        return response
    }
}
